import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DistributeHorizontalLeft"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21 16.5H18C17.6023 16.4996 17.221 16.3414 16.9398 16.0602 16.6586 15.779 16.5004 15.3977 16.5 15V9C16.5004 8.6023 16.6586 8.22101 16.9398 7.9398 17.221 7.65859 17.6023 7.50042 18 7.5H21C21.3977 7.50042 21.779 7.65859 22.0602 7.9398 22.3414 8.22101 22.4996 8.6023 22.5 9V15C22.4996 15.3977 22.3414 15.779 22.0602 16.0602 21.779 16.3414 21.3977 16.4996 21 16.5zM18 9V15H21V9H18zM15 1.5H13.5V22.5H15V1.5zM9 19.5H6C5.6023 19.4996 5.22101 19.3414 4.9398 19.0602 4.65859 18.779 4.50042 18.3977 4.5 18V6C4.50042 5.6023 4.65859 5.22101 4.9398 4.9398 5.22101 4.65859 5.6023 4.50042 6 4.5H9C9.3977 4.50042 9.77899 4.65859 10.0602 4.9398 10.3414 5.22101 10.4996 5.6023 10.5 6V18C10.4996 18.3977 10.3414 18.779 10.0602 19.0602 9.77899 19.3414 9.3977 19.4996 9 19.5zM6 6V18H9V6H6zM3 1.5H1.5V22.5H3V1.5z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DistributeHorizontalLeft.vue"]]);
